// import { markRaw } from "vue";
import { defineStore } from 'pinia'

export const useModal = defineStore('modal', {
    state: () => ({
        queue: [],
        open: false,
        resolve: null,
        default: {
            title: '',
            icon: undefined,
            text: '',
            body: '',
            footer: '',
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            confirmButtonColor: undefined,
            cancelButtonColor: undefined,
            open: false,
            endModal: undefined,
            preConfirm: undefined,
            wide: false,
        },
        props: {
            title: '',
            icon: '',
            text: '',
            body: '',
            footer: '',
            bodyClasses: null,
            showConfirmButton: true,
            confirmAwait: false,
            awaiting: false,
            result: null,
            showCancelButton: false,
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            confirmButtonColor: undefined,
            cancelButtonColor: undefined,
            open: false,
            endModal: undefined,
            preConfirm: undefined,
            //#region
            showCustomButton: false,
            customButtonText: '',
            customButtonColor: undefined,
            customButtonAction: undefined,
            //#endregion
            wide: false,
        },
    }),
    actions: {
        /**
         * @param {String} text
         * @param {String} title
         * @param {('error'|'success'|'info')} icon
         */
        async fireSimple(text, title, icon) {
            if (this.open) {
                this.queue.push({ text, title, icon })
            }
            let p = new Promise((res) => (this.resolve = res))
            this.props = { ...this.default, text, title, icon }
            setTimeout(() => {
                this.open = true
            }, 150)

            return p
        },
        /**
         * @param {Object} props
         * @param {String} props.title: '',
         * @param {('error'|'success'|'info')} icon
         * @param {String} props.text: '',
         * @param {String} props.body: '',
         * @param {String} props.footer: '',
         * @param {Object} props.bodyClasses: null,
         * @param {Boolean} props.showConfirmButton: true,
         * @param {String} props.confirmAwait: false,
         * @param {Boolean} props.showCancelButton: false,
         * @param {String} props.confirmButtonText: 'OK',
         * @param {String} props.cancelButtonText: 'Cancel',
         * @param {String} props.confirmButtonColor: undefined,
         * @param {String} props.cancelButtonColor: undefined,
         * @param {Boolean} props.showCustomButton: false,
         * @param {String} props.customButtonText: '',
         * @param {String} props.customButtonColor: undefined,
         * @param {String} props.customButtonAction: undefined,
         * @param {Boolean} props.wide: false,
         */
        async fire(props) {
            if (this.open) {
                this.queue.push(props)
            } else {
                let p = new Promise((res) => (this.resolve = res))
                this.props = { ...this.default, ...props }
                setTimeout(() => {
                    this.open = true
                }, 300)
                if (this.props.confirmAwait) {
                    this.props.awaiting = true
                    let interval = setInterval(async () => {
                        this.props.result = await this.props.preConfirm()
                    }, 1000)
                    while (!this.props.result) {
                        await new Promise((res) => setTimeout(res, 1000))
                    }
                    clearInterval(interval)
                    this.props.awaiting = false
                }
                return p
            }
        },
        async close(answer) {
            this.open = false
            await setTimeout(async () => {
                this.view = {}
                this.actions = []
                let preC = this.props.preConfirm
                this.props = this.default
                if (!answer) {
                    if (this.resolve && preC) {
                        await this.resolve({ res: answer })
                    } else if (this.resolve) {
                        await this.resolve(answer)
                    }
                } else {
                    if (this.resolve && preC && !this.props.confirmAwait) {
                        await this.resolve({ res: answer, props: await preC() })
                    }
                    if (this.resolve && preC && this.props.confirmAwait) {
                        await this.resolve({ res: this.props.result })
                    } else if (this.resolve) {
                        await this.resolve(answer)
                    }
                }
                if (this.queue.length > 0) {
                    this.fire(this.queue.shift())
                }
            }, 300)
        },
    },
})

export default useModal
